import React, { useMemo, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CloseIcon from "@mui/icons-material/Close";
import { GroupMember } from "../../lib/types";

interface TransferOwnershipModalProps {
  open: boolean;
  onClose: () => void;
  members: GroupMember[];
  onTransfer: (userId: string) => Promise<void> | void;
}

const TransferOwnershipModal: React.FC<TransferOwnershipModalProps> = ({
  open,
  onClose,
  members,
  onTransfer,
}) => {
  const eligibleMembers = useMemo(
    () => members.filter((member) => member.status === "active"),
    [members]
  );
  const [selectedUserId, setSelectedUserId] = useState(
    eligibleMembers[0]?.userId || ""
  );

  const handleTransfer = async () => {
    if (!selectedUserId) {
      return;
    }
    console.log("Transferring group ownership", { userId: selectedUserId });
    await onTransfer(selectedUserId);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Transfer ownership</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography color="text.secondary">
            Choose a new owner for this group. You will remain an admin.
          </Typography>
          <FormControl fullWidth>
            <InputLabel id="transfer-owner-label">New owner</InputLabel>
            <Select
              labelId="transfer-owner-label"
              value={selectedUserId}
              label="New owner"
              onChange={(event) =>
                setSelectedUserId(event.target.value as string)
              }
            >
              {eligibleMembers.map((member) => (
                <MenuItem key={member.userId} value={member.userId}>
                  {member.displayName || member.email || member.userId}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Tooltip title="Cancel">
          <IconButton
            onClick={() => {
              console.log("Canceling transfer ownership");
              onClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Transfer ownership">
          <IconButton onClick={handleTransfer}>
            <SwapHorizIcon />
          </IconButton>
        </Tooltip>
      </DialogActions>
    </Dialog>
  );
};

export default TransferOwnershipModal;
